import { RegisterOptions } from 'react-hook-form';

export const fieldRequired = ( message?: string, value = true ): RegisterOptions['required'] => {
  return {
    value,
    message: message || 'You must answer the question',
  };
};
